export default {"src":"/uk/_next/static/media/trust-pilot-logo.0c64bf5c.svg","height":31,"width":123,"blurWidth":0,"blurHeight":0};